<template>
  <div class="filter-wrapper sm:w-1/4 flex-grow relative border-t sm:border-t-0 sm:border-l border-white lg:pl-4" v-click-away="onClickAway">
    <button class="filter-button relative h-28 w-full text-sm flex justify-center items-center sm:flex-col transition-all" @click.prevent="onToggleOverlay">
      <svg class="w-8 h-8 sm:w-10 sm:h-10 mr-2 sm:mr-0 mb-2">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-ingredients" />
      </svg>
      Inhalte
      <svg
        class="collapse ml-4 sm:ml-0 sm:absolute transition-all"
        :class="{ 'active': show }">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-down" />
      </svg>
    </button>
    <div v-show="show" class="overlay w-full absolute top-28 right-0 bg-red-50 p-4 text-left shadow-lg">
      <h4 class="text-sm text-bold border-b border-black pb-1 mb-4">Nach Inhalten filtern</h4>
      <div class="grid grid-cols-2">
        <Tag
          v-for="tag in tags"
          :key="tag.id"
          :label="tag.name"
          :active="filter.tags.indexOf(tag.id) > -1"
          @select="onSelectTag(tag)" />
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as VueClickAway } from 'vue3-click-away'

import filterStore from '@/Store/filter'
import Tag from './Tag'

export default {
  name: 'TagFilter',
  mixins: [VueClickAway],
  components: { Tag },

  data: () => ({
    show: false,
    filter: filterStore.state
  }),

  computed: {
    tags() {
      return this.$page.props.tags
    }
  },

  methods: {
    onSelectTag(tag) {
      if (this.filter.tags.indexOf(tag.id) > -1) {
        filterStore.removeTagAction(tag)
      } else {
        filterStore.setTagAction(tag)
      }
    },

    onClickAway(event) {
      this.show = false
    },

    onToggleOverlay(event) {
      this.show = !this.show
    }
  }
}
</script>

<style scoped>
.filter-button {
  position: relative;
  z-index: 3;
  align-items: center;
  background-color: #cfc5a9;
  cursor: pointer;
  display: flex;
}

.filter-wrapper {
  min-width: 212px;
}

.filter-button:focus, .filter-button:hover {
  background-color: #c6ba99;
}

.overlay {
  background-color: #e3dcc8;
  min-width: 320px;
}

.collapse {
  height: .4375rem;
  width: 1.0625rem;
  left: 50%;
  bottom: 8px;
  transform: translateX(-50%);
}

.collapse.active {
  transform: translateX(-50%) rotate(180deg);
}
</style>
